import { Edit, ShieldCheck, Trash2 } from "lucide-react";
import { useRole } from "../../contexts/RoleContext";
import { useLocation } from "react-router-dom";
import { hasPermissionToActionButton } from "../../lib/utils";
import { useEffect } from "react";

function ActionButton({ openModal, item, handleDelete, setPermission }) {
  const location = useLocation();
  const pathname = location.pathname;
  const { role, loading } = useRole();

  const permission = hasPermissionToActionButton(role, pathname);
  useEffect(() => {
    setPermission(permission);
  }, []);
  return (
    <div className="flex items-center space-x-2">
      {permission.view && (
        <button
          onClick={() => openModal(item, "view")}
          className="text-gray-400 hover:text-gray-500"
        >
          <ShieldCheck className="h-4 w-4" />
        </button>
      )}
      {permission.update && (
        <button
          onClick={() => openModal(item, "edit")}
          className="text-blue-400 hover:text-blue-500"
        >
          <Edit className="h-4 w-4" />
        </button>
      )}
      {permission.delete && (
        <button
          className="text-red-400 hover:text-red-500"
          onClick={() => handleDelete.onOpen(item)}
        >
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default ActionButton;
